import fileUploadController from '~/config/server/file-service/file-upload.controller';
export var fileService = {
    fileUploadController: fileUploadController
};
